import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CssMgmtService {

  private stylesheets: StylesheetSummary[] = [
    { id: 'adminCss', url: '/css/admin-style.css' },
    { id: 'publicCss', url: '/css/public.css' },
    { id: 'loginCss', url: '/css/login.css' }
  ];

  constructor() { }

  public load(cssIds: string[]) {
    this.stylesheets.forEach(css => {
      if (cssIds.indexOf(css.id) >= 0) {
        if (!document.getElementById(css.id)) {
          var head = document.getElementsByTagName('head')[0];
          var link = document.createElement('link');
          link.id = css.id;
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.href = css.url;
          link.media = 'all';
          head.appendChild(link);
        } else {
          (document.getElementById(css.id) as HTMLLinkElement).disabled = false; // if it's already there, enable it
        }
      } else if (document.getElementById(css.id)) {
        (document.getElementById(css.id) as HTMLLinkElement).disabled = true; // for now, let's count on unload to deal with this
      }
    })
  }

  public unload(cssId: string) {
    if (document.getElementById(cssId)) {
      (document.getElementById(cssId) as HTMLLinkElement).disabled = true; // for now, let's count on unload to deal with this
    }
  }
}

class StylesheetSummary {
  id: string;
  url: string;
}